import type { CardPreviewProps } from "@/components/shapes/card-previews";
import { cardPaint } from "@/components/shapes/shared/card-paint";
import { GenericCardPreview } from "@/components/shapes/shared/generic-card-preview";
import { WeatherFace } from "./weather-face";
import { hasWeather, weatherFields } from "./weather-fields";

/** Weather: the sky of today's condition behind its face (`WeatherFace`). */
export function WeatherCardPreview(props: CardPreviewProps) {
  const fields = weatherFields(props.source);
  if (!hasWeather(fields)) return <GenericCardPreview {...props} />;
  return (
    <WeatherFace
      fields={fields}
      density={props.density}
      paint={cardPaint(props.frame).background}
      testIdPrefix="weather-card"
    />
  );
}
